import { type ModelDehydratedState, ModelStore } from '@/tools/models/model.store';

export type ScalingModelDehydratedState = ModelDehydratedState;

/**
 * Store for models within scaling tables
 * Models can be created and edited in multiple places (e.g. tool pane, scaling tables)
 * so we need a dedicated store for the model tool to avoid conflicts with other places.
 */
export class ScalingModelStore extends ModelStore {
  static readonly storeName = 'sqScalingModelStore';

  override dehydrate(): ScalingModelDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ScalingModelDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  protected override readonly handlers = {
    ...this.baseHandlers,
    SCALING_MODEL_RESET_MODEL: this.resetModel,
    SCALING_MODEL_SET_MODEL: this.setModel,
    SCALING_MODEL_SET_FEATURE_TO_EDIT_ID: this.setFeatureToEditId,
    SCALING_MODEL_SET_INSTANCE_TO_EDIT_ID: this.setInstanceToEditId,
    SCALING_MODEL_SET_MODEL_OUTPUT: this.setModelOutput,
    SCALING_MODEL_SET_VERSION_STATE: this.setVersionState,
  };
}
